import { Link } from '@tanstack/react-router';
import type React from 'react';
import AdminNavBarUserName from 'src/Administration/TopNavbar/AdminNavBarUserName';
import styles from 'src/Administration/TopNavbar/TopNavbarStyles';
import { HOME_PATH } from 'src/constants';
import NavLogo from 'src/HomePage/TopNavBar/AkomiLogo/AkomiNavLogo';
import { useFilterReset } from 'src/helpers/filters';

const TopNavBar = (): React.ReactElement => {
  const reset = useFilterReset();

  const systemAdminLogoHandler = (): void => {
    reset();
  };

  const classes = styles();

  return (
    <div className={classes.topNavBar}>
      <div className={classes.topNavBarItems} style={{ height: 48 }}>
        <Link to={`${HOME_PATH}`} onClick={systemAdminLogoHandler}>
          <NavLogo />
        </Link>
        <div>System Administration</div>
        <AdminNavBarUserName />
      </div>
    </div>
  );
};

export default TopNavBar;
